import { Button, Col, Form, Row, Input, Card } from "antd";
import React, { useCallback, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import CustomerHeader from "./Layout/topHeader";
import { responseNotification } from "../../utils/notify";
import { SET_DRIVER_INFO } from "../../redux/auth/authType";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import ShopLayout from "./Layout";

const MerchantCashPay = () => {
  const { driverInfo } = useSelector((state) => (state as any)?.authReducer);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const route = useParams();
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const onSubmit = async (data) => {
    setLoading(true);

    const readyData = data && {
      shopId: (route as any)?.id as string,
      amount: data.amount,
      note: data?.note,
    };

    await fetch(
      `${process.env.REACT_APP_RIDER_API}/admin/transaction/cash-collection`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...readyData,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);
        if (res.statusCode === 200) {
          responseNotification("Cash Pay Successfully!!!", "success");
          form.resetFields();
          fetchDriverDetails((route as any)?.shopId);
          history.push(`/drivers/${(route as any)?.shopId as string}/transactions`);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const fetchDriverDetails = useCallback((getDriverId) => {
    if (getDriverId) {
      try {
        axios
          .get(
            `${process.env.REACT_APP_RIDER_API}/admin/driver/${getDriverId}`,
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
                "Content-Type": "application/json",
              },
            }
          )
          .then((data) => {
            if (data.status === 200) {
              dispatch({
                type: SET_DRIVER_INFO,
                payload: {
                  driverInfo: {
                    image: data?.data?.driver?.image,
                    name: data?.data?.driver?.name,
                    mobileNumber: data?.data?.driver?.mobileNumber,
                    balance: data?.data?.driver?.balance,
                    rating: data?.data?.driver?.rating,
                    // status: data?.data?.driver?.status,
                  },
                },
              });
            } else {
              responseNotification(
                data.statusText || "something went wrong",
                "error"
              );
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (error) {
        console.log(error, "error");
      }
    }
  }, []);

  return (
    <React.Fragment>
      <ShopLayout shopId={(route as any)?.shopId as string}>
        <div className="bg-white" style={{ minHeight: 750 }}>
          <CustomerHeader
            leftarea={"Collect Cash From Delivery Hero"}
            rightarea={""}
          />

          <Row align="middle" justify="center" style={{ minHeight: "100%" }}>
            <Col span={10}>
              <Card>
                <Form
                  name="control-hooks"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  className="ant-form ant-form-vertical"
                  onFinish={onSubmit}
                  form={form} // like ref
                  layout="vertical"
                >
                  <Form.Item
                    name={"amount"}
                    label="Amount"
                    rules={[
                      { required: true },
                      {
                        validator: async (_, value) => {
                          if (value > driverInfo?.balance) {
                            return Promise.reject(
                              new Error(
                                "Amount Must be Equal or less than Balance"
                              )
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Input type="number" placeholder="Enter Collected Amount" />
                  </Form.Item>

                  <Form.Item
                    name="note"
                    label="Note"
                    rules={[{ required: true }]}
                  >
                    <Input.TextArea
                      placeholder="Please write some note or description..."
                      rows={5}
                    />
                  </Form.Item>
                  <Button type="primary" htmlType="submit">
                    Submit
                  </Button>
                </Form>
              </Card>
            </Col>
          </Row>
        </div>
      </ShopLayout>
    </React.Fragment>
  );
};

export default MerchantCashPay;
